var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 11.6357,
    cy: 6.5,
    r: 6.5,
    fill: "#68CFC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38574 10.4167L7.13574 12.1667L11.8024 7.5",
    stroke: "#68CFC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8021 11.0007V14.5007C11.8021 14.8101 11.6792 15.1068 11.4604 15.3256C11.2416 15.5444 10.9448 15.6673 10.6354 15.6673H3.63542C3.326 15.6673 3.02925 15.5444 2.81046 15.3256C2.59167 15.1068 2.46875 14.8101 2.46875 14.5007V7.50065C2.46875 7.19123 2.59167 6.89449 2.81046 6.67569C3.02925 6.4569 3.326 6.33398 3.63542 6.33398H8.88542",
    stroke: "#68CFC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checkedIcon.b65f5ef55f78fb590bfcd00a7222f00e.svg";
export { ForwardRef as ReactComponent };